<template>
  <div>
  </div>
</template>
<script>
  // import swal from 'sweetalert'
  import axios from 'axios'
import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {}
    },
    created() {
      this.checkUserid()
    },
    mounted() {},
    methods: {
      checkUserid() {
        let login_href = window.location.href
        // let login_href = "https://lapi.gdfanqie.com"
        let token = localStorage.getItem('access_token');
        console.log("token", token)
        if (!!token && token != 'undefined') {

        } else {
          let code = this.getParameterByName('code');
          console.log("code1111", code)
          // let lottery_code = ""
          // if (this.getSourceByName("lottery_code")) {
          //   lottery_code = this.getSourceByName("lottery_code")
          //   sessionStorage.setItem("lottery_code", lottery_code)
          // } else {
          //   lottery_code = "122021061596"
          //   sessionStorage.setItem("lottery_code", lottery_code)
          // }
          // let source = ""
          // let source1 = this.getSourceByName("source")
          // if(source1!= sessionStorage.getItem("source")){
          //   sessionStorage.removeItem("source")
          //   localStorage.removeItem('access_token');
          //   localStorage.removeItem('userinfo');
          //   sessionStorage.setItem("source", source1)
          //   source = source1
          // }else{
          //   source = sessionStorage.getItem('source')
          // }

          if (!code) {
            //跳转授权页
            window.location.href =
              'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxda25fb34ce4dd74d&redirect_uri=' +
              encodeURIComponent(login_href) +
              '&response_type=code&scope=snsapi_userinfo&state=fanqieservice#wechat_redirect';
            //snsapi_userinfo snsapi_base
          } else {

            var url = 'https://mapi.gdfanqie.com/wechat/user/access-token?code=' + code;
            //var url = 'https://antwechat.yqhinfo.com/wechat/user/access-token?code=' + code;
            //var url = 'https://wechat.linkces.com/wechat/user/access-token?code='+ code;
            //url = !lottery_code ? url : url + '&lottery_code=' + lottery_code;
            //let url = !source ? "'https://wechat.linkces.com/wechat/user/access-token?code='+ code " : "'https://wechat.linkces.com/wechat/user/access-token?code=' + code'&source='+source"
            axios.get(url).then(function(res) {
              if (res.data.code == 0) {
                localStorage.setItem('userinfo', JSON.stringify(res.data.data));
                localStorage.setItem('access_token', res.data.data.access_token);
                localStorage.setItem('mobile', res.data.data.mobile);
                console.log("userinfo", localStorage.getItem('userinfo'))
                let userinfo = localStorage.getItem('userinfo')
                let last_location_href = localStorage.getItem('last_location_href');
                // var that = this
                // console.log("userinfo.is_bind == 0",userinfo.is_bind == 0)
                // if (userinfo.is_bind == 0) {
                //   Dialog.alert({
                //     title: '提示',
                //     message: '请先绑定商家账号',
                //     theme: 'round-button',
                //   }).then(() => {
                //     that.$router.push({
                //       path: "/signIn"
                //     })
                //   });
                // } else {
                //   that.$router.push({
                //     path: "/"
                //   })
                // }
                // console.log('进来前的页面路径2', last_location_href)
                if (last_location_href) {
                  localStorage.removeItem('last_location_href') //移除缓存再跳转
                  window.location.href = last_location_href
                } else {
                  window.location.href = "https://merchant.gdfanqie.com"
                  //window.location.href = "https://m.linkces.com"
                }
              } else {
                this.$toast({
                  message: '登录失败,请重试',
                })
              }
            })
          }
        }
      },
      getParameterByName(name) {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.search);
        if (results == null) {
          return "";
        } else {
          return decodeURIComponent(results[1].replace(/\+/g, " "));
        }
      },
      getSourceByName(name) {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.search);
        if (results == null) {
          return "";
        } else {
          return decodeURIComponent(results[1].replace(/\+/g, " "));
        }
      },
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue